<template>
  <div class="app-footer">
    <p class="intro">Get Rubies Now</p>
    <p class="download-links">
      <span>
        <a
          href="https://play.google.com/store/apps/details?id=com.qucoon.rubies"
        >
          <img
            src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/play-store.png"
            alt="play-store"
          />
        </a>
      </span>
      <span>
        <a href="https://apps.apple.com/au/app/rubies/id1458430556">
          <img
            src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/app-store.png"
            alt="app-store"
          />
        </a>
      </span>
      <span>
        <a href="http://ibank.rubies.ng/">
          <img
            src="https://rubies-ibank-test-two.s3-us-west-2.amazonaws.com/img/new-rubies/donate.rubies.com/rubies-web.png"
            alt="rubies-web"
          />
        </a>
      </span>
    </p>
  </div>
</template>

<script>
export default {
  name: "AppFooter"
};
</script>

<style scoped></style>
